import React, { useState } from "react";
import styles from "./CalendarDay.module.css";
import Button from "./Button";
import { useNavigate } from "react-router-dom";
import { useSiteInfo } from "../context/SiteContext";

function CalendarDay({ day, style, theDate, theEvents }) {
  const userLocation = JSON.parse(localStorage.getItem("userLogin")).location;

  return (
    <div className={`${styles.day} ${styles[style]}`}>
      <div className={styles.dayHeader}>
        <p>
          <CreateEventModal theDate={theDate} />
        </p>
        <p>{day}</p>
      </div>
      <div className={styles.dayBody}>
        {theEvents.length > 0 &&
          theEvents.map((theEvent) => {
            if (userLocation == 0 || userLocation == theEvent.LocationID) {
              return (
                <div className={styles.event} key={theEvent.idBanquetHeader}>
                  <a
                    href={`/event/${theEvent.idBanquetHeader}`}
                    style={{ backgroundColor: theEvent.color }}
                    title={theEvent.RoomName}
                    className={styles.eventLink}
                  >
                    {theEvent.BanquetName}
                  </a>
                </div>
              );
            }
          })}
      </div>
    </div>
  );
}

function CreateEventModal({ theDate }) {
  const locations = JSON.parse(sessionStorage.getItem("locations"));
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(1);
  const navigate = useNavigate();

  const openModal = () => {
    setIsOpen((x) => !x);
  };
  const closeModal = () => {
    setIsOpen((x) => !x);
  };
  const handleCreate = (d, r) => {
    navigate(`/newevent?d=${d}&r=${r}`);
  };
  const changeLocation = (e) => {
    e.preventDefault();
    setSelectedLocation(Number(e.target.value));
  };

  return (
    <>
      <a>
        <i className="fa-solid fa-plus isLink" onClick={openModal}></i>
      </a>
      {isOpen && (
        <div className="modal-backdrop modal-backdrop-dark">
          <div className={`modal-content modal-narrow ${styles.modalTop}`}>
            <h3 className="modal-header">Add Banquet Event</h3>
            <p>
              Add new banquet event on{" "}
              {theDate.toLocaleDateString(undefined, {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </p>
            <div className={styles.formSelect}>
              <label>Select Restaurant</label>
              <select onChange={changeLocation}>
                {locations.map((location) => {
                  return (
                    <option value={location.idLocation} key={location.idLocation}>
                      {location.Description}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className={styles.formSelectButtons}>
              <Button type="primary" onClick={() => handleCreate(theDate.toISOString(), selectedLocation)}>
                Save
              </Button>
              <Button type="save" onClick={closeModal}>
                Close
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CalendarDay;
